module.exports = __webpack_public_path__ + "static/media/serviceArea.8163a5e9.png";